import { connect } from "react-redux";
import { SliderGroup as Component } from "./SliderGroup";
import { selectNewSequenceInGroup } from "@learningblocks/protocol-redux/lib/Actions";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    changeHighlight: (params) => {
      dispatch(selectNewSequenceInGroup(params));
    },
  };
}

export const SliderGroup = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
